export enum LoginType {
  PASSWORD = 'password',
  MFA = 'mfa',
  SMS = 'sms',
  WECHAT = 'wechat'
}

export const isValidLoginType = (type: string): type is LoginType => {
  return Object.values(LoginType).includes(type as LoginType)
}
